export default {
  isWeChat: function () {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
  },
  getQueryString: function (name, url) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r;
    if (url && url !== '') {
      url = url.substring(url.indexOf('?'), url.lastIndexOf('#'));
      r = url.substr(1).match(reg)
    } else {
      r = window.location.search.substr(1).match(reg)
    }
    if (r !== null) {
      return unescape(r[2])
    }
    return ''
  },
  permanentStorage: function (key, value) {
    if (arguments.length === 1) {
      return localStorage.getItem(key)
    } else {
      if (value === null) {
        localStorage.removeItem(key);
        return
      }
      value = value === undefined ? '' : value;
      value = JSON.stringify(value);
      localStorage.setItem(key, value)
    }
  },
  tempStorage: function () {
  },
  checkTelPhoneNumber: function (number) {
    if (!number) {
      return false
    }
    number = parseInt(number);
    if (number === 'NaN') {
      return false
    }
    let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    return reg.test(number)
  },
}



// WEBPACK FOOTER //
// ./common/common.js